import Wrapper from "./Header.styles"
import logo from "../../assets/logo.svg"
import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { NavigationRoutes } from "../../Constants/Routes"
import { GetHelp } from "../Shared/GetHelp"
import { Nav } from "./Nav"
import { Subscription } from "./Subscription"
import axios from "axios"
import LocalStorage, { Keys } from "../../Storage/LocalStorage"
export const Header = ({ names, subscriptions, allowChart }) => {

    const [showGetHelp, setShowGetHelp] = useState(false)
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false)

    const logout = () => {
        window.localStorage.clear()
    }

    useEffect(() => {
        if (subscriptions && subscriptions.length > 1) {
            if (!LocalStorage.get(Keys.CURRENT_SUBSCRIPTION)) {
                setShowSubscriptionPopup(true)
            }
        }

    }, [subscriptions])


    return (
        <Wrapper className="header">

            {
                showSubscriptionPopup && subscriptions && subscriptions.length ?
                    <Subscription
                        data={subscriptions}
                        show={setShowSubscriptionPopup}
                        isMandatory={!LocalStorage.get(Keys.CURRENT_SUBSCRIPTION)}
                    />
                    : null
            }

            {
                showGetHelp
                    ? <GetHelp setShowGetHelp={setShowGetHelp} />
                    : null
            }

            <div className="innerHeader">
                <Link to={NavigationRoutes.HOME} className="logo" aria-label="McKinsey & Company">
                        <img src={logo} alt="McKinsey & Company" height="42" />
                    </Link>
                <Nav setShowGetHelp={setShowGetHelp} allowChart={allowChart} />
                <div className="spacer"></div>
                <input
                    type="button"
                    className="user"
                    value={names.firstName && names.lastName ? (names.firstName[0] + names.lastName[0]) : 'UU'}
                />

                <div className="user-overlay">
                    <ul>
                        {
                            subscriptions && subscriptions.length > 1
                                ? <li>
                                    <input
                                        type="button"
                                        value="Manage Subscription"
                                        title="Manage Subscription"
                                        onClick={e => setShowSubscriptionPopup(true)}
                                    />
                                </li> : null
                        }
                        <li>
                            <input type="button" value="Logout" onClick={logout} />
                        </li>
                    </ul>
                </div>
            </div>
        </Wrapper>
    )
}
